//库存统计--按门店
export let storeEcharts = {
  id: "storeEcharts",
  charsOption: {
    title: {
      top:5,
      right:0,
      text: '',
      textStyle: {color: "#ccc", fontSize: "18", fontWeight: "400"},
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    },
    //上方小按钮
    toolbox: {
      itemSize: 23,
      show: true,
      feature: {
        mark: {show: true},
        dataView: {show: false, readOnly: true, title: '表格', textareaBorderColor: '#e9e9e9'},
        magicType: {show: true, type: ['line', 'bar']},
        restore: {show: true},
        saveAsImage: {show: true}
      }
    },
    calculable: true,
    legend: {
      data: ["库存量", "可售总额", "成本总额"],
      itemGap: 5
    },
    color:['#017eff', '#8bd345','#5f58e6'],
    grid: {
      top: '12%',
      left: '0%',
      right: '3%',
      bottom:"3%",
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        data: []
      }
    ],
    yAxis: [
      {
        type: 'value',
      }
    ],
    dataZoom: [
      {
        show: false,
        start:0,
        end: 100
      },
      {
        type: 'inside',
        start: 94,
        end: 100
      },
      {
        show: false,
        yAxisIndex: 0,
        filterMode: 'empty',
        width: 30,
        height: '80%',
        showDataShadow: false,
        left: '93%'
      }
    ],
    series: [
      {
        name: '库存量',
        type: 'bar',
        barGap: 6,
        data: []
      },
      {
        name: '可售总额',
        type: 'bar',
        barGap: 6,
        data: []
      },
      {
        name: '成本总额',
        type: 'bar',
        barGap: 6,
        data: []
      },
    ]
  }
};

//库存统计--按分类
export let categoryEcharts = {
  id: "categoryEcharts",
  charsOption: {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    },
    //上方小按钮
    toolbox: {
      itemSize: 23,
      feature: {
        mark: {show: true},
        dataView: {show: false, readOnly: false},
        magicType: {show: true, type: ['line', 'bar']},
        restore: {show: true},
        saveAsImage: {show: true}
      }
    },
    calculable: true,
    legend: {
      data: ["库存量", "可售总额", "成本总额"],
      itemGap: 8
    },
    color:['#017eff', '#8bd345','#5f58e6'],
    grid: {
      top: '12%',
      left: '3%',
      right: '5%',
      bottom:"4%",
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        data: []
      }
    ],
    yAxis: [
      {
        type: 'value',
      }
    ],
    dataZoom: [
      {
        show: false,
        start: 0,
        end: 100
      },
      {
        type: 'inside',
        start: 94,
        end: 100
      },
      {
        show: false,
        yAxisIndex: 0,
        filterMode: 'empty',
        width: 30,
        height: '80%',
        showDataShadow: false,
        left: '93%'
      }
    ],
    series: [
      {
        name: '库存量',
        type: 'bar',
        barGap: 6,
        data: []
      },
      {
        name: '可售总额',
        type: 'bar',
        barGap: 6,
        data: []
      },
      {
        name: '成本总额',
        type: 'bar',
        barGap: 6,
        data: []
      },
    ]
  }
};
//库存统计--按供应商
export let merchantEcharts = {
  id: "merchantEcharts",
  charsOption: {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    },
    //上方小按钮
    toolbox: {
      itemSize: 23,
      show: true,
      feature: {
        mark: {show: true},
        dataView: {show: false, readOnly: false},
        magicType: {show: true, type: ['line', 'bar']},
        restore: {show: true},
        saveAsImage: {show: true}
      }
    },
    calculable: true,
    legend: {
      data: ["库存量", "可售总额", "成本总额"],
      itemGap: 5
    },
    color:['#017eff', '#8bd345','#5f58e6'],
    grid: {
      top: '11%',
      left: '3%',
      right: '3%',
      bottom:"3%",
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        data: []
      }
    ],
    yAxis: [
      {
        type: 'value',
      }
    ],
    dataZoom: [
      {
        show: false,
        start: 0,
        end: 100
      },
      {
        type: 'inside',
        start: 94,
        end: 100
      },
      {
        show: false,
        yAxisIndex: 0,
        filterMode: 'empty',
        width: 30,
        height: '80%',
        showDataShadow: false,
        left: '93%'
      }
    ],
    series: [
      {
        name: '库存量',
        type: 'bar',
        barGap: 6,
        data: []
      },
      {
        name: '可售总额',
        type: 'bar',
        barGap: 6,
        data: []
      },
      {
        name: '成本总额',
        type: 'bar',
        barGap: 6,
        data: []
      },
    ]
  }
};

//会员增长统计
export let reportStatistics = {
  id: "reportStatistics",
  charsOption: {
    title: {
        text: ' ',
        left:0,
        top:0,
        textStyle: {color: "#ccc", fontSize: "18", fontWeight: "400"},
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    },
    color: ['#00ccff', '#fb4451','#6d5ffc'],
    legend: {
      data: ['新增会员数', '下单人数', '会员转化率']
    },
    grid: {
      top: '11%',
      left: '0%',
      right: '3%',
      bottom: '3%',
      containLabel: true
      },
    xAxis: [
      {
        type: 'category',
        data: [],
        axisPointer: {
          type: 'shadow'
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '',
        // min: 0,
        // max: 5,
        // interval: 1,
        axisLabel: {
          formatter: '{value} 个'
        }
      },
      {
        type: 'value',
        name: '',
        min: 0,
        max: 100,
        interval: 20,
        axisLabel: {
          formatter: '{value} %'
        }
      }
    ],
    series: [
      {
        name: '新增会员数',
        type: 'bar',
        barWidth:50,
        data: []
      },
      {
        name: '下单人数',
        type: 'line',
        data: [],
        smooth:true
      },
      {
        name: '会员转化率',
        type: 'line',
        yAxisIndex: 1,
        data: [],
        smooth:true
      }
    ]
  }
};

//会员构成分析--按开卡门店
export let mstoreEcharts = {
  id: "mstoreEcharts",

  charsOption: {
    title: {
      top:5,
      right:0,
      text: '会员分析（会员数）-开卡门店 ',
      textStyle: {color: "#ccc", fontSize: "18", fontWeight: "400"},
    },
    tooltip: {
      formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    legend: {
      orient: 'vertical',
      left: 0,
      data: []
    },
    color:['#2ec7c9', '#b6a2de','#8fd3e8','#71669e',"#cc70af","#7cb4cc"],
    toolbox: {
      top:30,
      right:20,
      // orient: 'vertical',
      itemSize: 23,
      show: true,
      optionToContent: function (opt) {
        let series = opt.series;
        let title = opt.title;
        let table = '<table border="1" style="width:100%;text-align:center";border-collapse:collapse;><tbody><tr style="height:30px;>'
          + '<h1 style="text-align:center;>' + title[0].text + '</h1>'
          + '<td style="background:#efefef;">序号</td>'
          + '<td style="background:#efefef;">开卡门店</td>'
          + '<td style="background:#efefef;">会员总数</td>'
          + '<td style="background:#efefef;">会员余额</td>'
          + '</tr>';
          for(var i=0;i<series[0].data.length;i++){
              table += '<tr>'
              + '<td>' + `${i+1}` + '</td>'
              + '<td>' + series[0].data[i].name + '</td>'
              + '<td>' + series[0].data[i].value + '</td>'
              + '<td>' + series[0].data[i].balance + '</td>'
              + '<tr>'
          }
        table += '</tbody></table>';
        return table;
      },
      feature: {
        mark: {show: true},
        dataView: {show: true, readOnly: true, title: '表格', textareaBorderColor: '#e9e9e9'},
        magicType: {show: true, type: ['pie']},
        restore: {show: true},
        saveAsImage: {show: true}
      }
    },
    series: [
      {
        name: '来源',
        type: 'pie',
        radius: '87%',
        center: ['50%', '55%'],
        data: [],
        emphasis: {
          itemStyle: {
            shadowBlur: 20,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          },

        }
      }
    ]
  }
};
//会员构成分析 -按会员分类
export let mcategoryEcharts = {
  id: "mcategoryEcharts",
  charsOption: {
    title: {
      top:5,
      right:0,
      text: '会员分析（会员数）-按会员分类 ',
      textStyle: {color: "#ccc", fontSize: "18", fontWeight: "400"},
    },
    tooltip: {
      formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    legend: {
      orient: 'vertical',
      left: 0,
      data: []
    },
    color:['#2ec7c9', '#b6a2de','#8fd3e8','#71669e',"#cc70af","#7cb4cc"],
    toolbox: {
      top:30,
      right:20,
      // orient: 'vertical',
      itemSize: 23,
      show: true,
      optionToContent: function (opt) {
        let series = opt.series;
        let title = opt.title;
        let table = '<table border="1" style="width:100%;text-align:center";border-collapse:collapse;><tbody><tr style="height:30px;>'
          + '<h1 style="text-align:center;">' + title[0].text + '</h1>'
          + '<td style="background:#efefef;">序号</td>'
          + '<td style="background:#efefef;">会员分类</td>'
          + '<td style="background:#efefef;">会员总数</td>'
          + '<td style="background:#efefef;">会员余额</td>'
          + '</tr>';
          for(var i=0;i<series[0].data.length;i++){
              table += '<tr>'
              + '<td>' + `${i+1}` + '</td>'
              + '<td>' + series[0].data[i].name + '</td>'
              + '<td>' + series[0].data[i].value + '</td>'
              + '<td>' + series[0].data[i].balance + '</td>'
              + '<tr>'
          }
        table += '</tbody></table>';
        return table;
      },
      feature: {
        mark: {show: true},
        dataView: {show: true, readOnly: true, title: '表格', textareaBorderColor: '#e9e9e9'},
        magicType: {show: true, type: ['pie']},
        restore: {show: true},
        saveAsImage: {show: true}
      }
    },
    series: [
      {
        name: '来源',
        type: 'pie',
        radius: '87%',
        center: ['50%', '55%'],
        data: [],
        emphasis: {
          itemStyle: {
            shadowBlur: 20,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          },

        }
      }
    ]
  }
};

//会员消费汇总
export let reportConsumptionSummary = {
  id: "reportStatistics",
  charsOption: {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    },
    color: ["#00ccff", "#ff3a43"],
    legend: {
      data: ['消费总数', '交易笔数']
    },
    grid: {
      top: '11%',
      left: '0%',
      right: '3%',
      bottom: '3%',
      containLabel: true
      },
    xAxis: [
      {
        type: 'category',
        data: [],
        axisPointer: {
          type: 'shadow'
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '',
        // max: 1800,
        // interval: 300,
        axisLabel: {
          formatter: '{value} 元'
        }
      },

    ],
    series: [
      {
        name: '消费总数',
        barWidth:'50',
        type: 'bar',
        data: []
      },
      {
        name: '交易笔数',
        type: 'line',
        data: []
      },
    ]
  }
};
//商品概览 商品分类消费排名--按销量
export let gcategorySaleEcharts = {
  id: "gcategorySaleEcharts",
  charsOption: {
    title: {
      text:"",
      left:0,
      top:0,
      textStyle: {color: "#ccc", fontSize: "14", fontWeight: "400"},
    },
    tooltip: {
      formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    legend: {
      orient: 'vertical',
      left: 0,
      data: []
    },
    color:[ '#f86055','#017eff',"#5f58e6","#8bd345","#a47a7a",'#ffcf29','#9b8bba',"#ce7676","#e35788"],
    series: [
      {
        name: '来源',
        type: 'pie',
        radius: ['50%', '75%'],
        center: ['50%', '50%'],
        avoidLabelOverlap: false,
        label: {
            show: false,
            position: 'center'
        },
        emphasis: {
            label: {
                show:true,
                fontSize: '16',
                fontWeight: 'bold'
            }
        },
        labelLine: {
            show: false
        },
        data: []
    }
    ]
  }
};
//商品概览 商品分类消费排名--按金额
export let gcategoryCashEcharts = {
  id: "gcategoryCashEcharts",
  charsOption: {
    title: {
      text:"",
      left:0,
      top:0,
      textStyle: {color: "#ccc", fontSize: "14", fontWeight: "400"},
    },
    tooltip: {
      formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    legend: {
      orient: 'vertical',
      left: 0,
      data: []
    },
    color:[ '#f86055','#017eff',"#5f58e6","#8bd345",'#ffcf29','#9b8bba',"#a47a7a","#ce7676","#e35788"],
    series: [
      {
        name: '来源',
        type: 'pie',
        radius: ['50%', '75%'],
        center: ['50%', '50%'],
        avoidLabelOverlap: false,
        label: {
            show: false,
            position: 'center'
        },
        emphasis: {
            label: {
                show:true,
                fontSize: '16',
                fontWeight: 'bold'
            }
        },
        labelLine: {
            show: false
        },
        data: []
    }
    ]
  }
};
//商品概览 普通商品销售排名  --按销量
export let generalSaleEcharts = {
  id: "generalSaleEcharts",
  charsOption: {
    title: {
      text:"",
     left:0,
     top:0,
      textStyle: {color: "#ccc", fontSize: "14", fontWeight: "400"},
    },
    tooltip: {
      formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    legend: {
      orient: 'vertical',
      left: 0,
      data: []
    },
    color:[ '#f86055','#017eff',"#5f58e6","#8bd345",'#ffcf29','#9b8bba',"#a47a7a","#ce7676","#e35788"],
    series: [
      {
        name: '来源',
        type: 'pie',
        radius: ['50%', '75%'],
        center: ['50%', '50%'],
        avoidLabelOverlap: false,
        label: {
            show: false,
            position: 'center'
        },
        emphasis: {
            label: {
                show:true,
                fontSize: '16',
                fontWeight: 'bold'
            }
        },
        labelLine: {
            show: false
        },
        data: []
    }
    ]
  }
};
//商品概览 普通商品销售排名  --按金额
export let generalCashEcharts = {
  id: "generalCashEcharts",
  charsOption: {
    title: {
      text:"",
      left:0,
      top:0,
      textStyle: {color: "#ccc", fontSize: "14", fontWeight: "400"},
    },
    tooltip: {
      formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    legend: {
      orient: 'vertical',
      left: 0,
      data: []
    },
    color:[ '#f86055','#017eff',"#5f58e6","#8bd345",'#ffcf29','#9b8bba',"#a47a7a","#ce7676","#e35788"],
    series: [
      {
        name: '来源',
        type: 'pie',
        radius: ['50%', '75%'],
        center: ['50%', '50%'],
        avoidLabelOverlap: false,
        label: {
            show: false,
            position: 'center'
        },
        emphasis: {
            label: {
                show:true,
                fontSize: '16',
                fontWeight: 'bold'
            }
        },
        labelLine: {
            show: false
        },
        data: []
    }
    ]
  }
};
//商品概览 报损状况
export let lossEcharts = {
  id: "lossEcharts",
  charsOption: {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        animation: false
      }
    },
    grid: {
      top: '9%',
      left: '3%',
      right: '5%',
      bottom: '0%',
      containLabel: true
      },
    legend: {
      data: ['报损数量（件）'],
      top:"0%"
    },
    color:['#59c4e6'],
    xAxis: {
      type: 'category',
      splitLine: {
        show: false
      },
      data: []
    },
    yAxis: {
      type: 'value',
      boundaryGap: [0, '100%'],
      splitLine: {
        show: false
      },
    },
    //下方滚动条
    dataZoom: [{
      type: 'inside',
      start: 99,
      end: 100
    }, {
      show: false,
      start: 0,
      end: 10,
      handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
      handleSize: '80%',
      handleStyle: {
        color: '#fff',
        shadowBlur: 3,
        shadowColor: 'rgba(0, 0, 0, 0)',
        shadowOffsetX: 2,
        shadowOffsetY: 2
      }
    }],
    series: [
      {
        name: '报损数量（件）',
        type: 'line',
        showSymbol: true,
        hoverAnimation: false,
        data: [],
        symbolSize: 8,
      },
    ]
  }
};
//商品概览 库存变动
export let InventoryEcharts = {
  id: "InventoryEcharts",
  charsOption: {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
        label: {
          show: true
        }
      }
    },
    dataZoom: [
      {
        show: false,
        start: 0,
        end: 100
      },
      {
        type: 'inside',
        start: 0,
        end: 100
      },
      {
        show: false,
        yAxisIndex: 0,
        filterMode: 'empty',
        width: 30,
        height: '80%',
        showDataShadow: false,
        left: '93%'
      }
    ],
    color: ['#0088dd'],
    calculable: true,
    legend: {
      data: ["库存量"],
      itemGap: 5,

    },
    grid: {
      top: '12%',
      left: '3%',
      right: '3%',
      bottom:'0%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        data: []
      }
    ],
    yAxis: [
      {
        type: 'value',
      }
    ],
    series: [
      {
        name: '库存量',
        type: 'bar',
        barGap: 6,
        barWidth:'20',
        data: []
      },
    ]
  }
};
//会员概览--客价单分布统计
export let customerListEcharts={
  id:"customerListEcharts",
  charsOption:{
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)'
  },
  title: {
    text:"",
    left:0,
    top:0,
    textStyle: {color: "#ccc", fontSize: "18", fontWeight: "400"},
},
  legend: {
      orient: 'vertical',
      // left: 10,
      right:"40%",
      top:'30%',
      data: ['0~15元', '15~30元', '30~45元', '45~60元']
  },

  color:["#e87c25","#fe8463","#fad860","#9bca63"],
  series: [
      {
          name: '来源',
          type: 'pie',
          radius: ['50%', '75%'],
          center: ['20%', '50%'],
          avoidLabelOverlap: false,
          label: {
              show: false,
              position: 'center'
          },
          emphasis: {
              label: {
                  show: false,
                  fontSize: '20',
                  fontWeight: 'bold'
              }
          },
          labelLine: {
              show: false
          },
          data: [
              {value: 335, name: '0~15元'},
              {value: 310, name: '15~30元'},
              {value: 234, name: '30~45元'},
              {value: 135, name: '45~60元'},
          ]
      }
  ]
  }
}
//会员概览-等级分布统计
export let levelEcharts={
  id:"levelEcharts",
  charsOption:{
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)'
  },
  title: {
    text:"",
    left:0,
    top:0,
    textStyle: {color: "#ccc", fontSize: "18", fontWeight: "400"},
},
  legend: {
      orient: 'vertical',
      // left: 10,
      right:"40%",
      top:'30%',
      data: []
  },

  color:["#ef5537","#f3a43b","#fcce10","#b5c334","#26c0c0","#60c0dd","#cbb0e3"],
  series: [
      {
          name: '来源',
          type: 'pie',
          radius: ['50%', '75%'],
          center: ['20%', '50%'],
          avoidLabelOverlap: false,
          label: {
              show: false,
              position: 'center'
          },
          emphasis: {
              label: {
                  show:false,
                  fontSize: '20',
                  fontWeight: 'bold'
              }
          },
          labelLine: {
              show: false
          },
          data: []
      }
  ]
  }
}
//会员概览--会员消费次数统计
export let mConsumptionEcharts = {
  id: "mConsumptionEcharts",
  charsOption: {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    },
    color: ['#9b8bba', '#e098c7','#8fd3e8'],
    legend: {
      data: ['会员消费次数']
    },
    grid: {
      top: '9%',
      left: '3%',
      right: '5%',
      bottom: '8%',
      containLabel: true
      },
    xAxis: [
      {
        type: 'category',
        data: [],
        axisPointer: {
          type: 'shadow'
        },
        splitLine: {
          show: true
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          formatter: '{value}人 '
      },
      splitLine: {
        show: true
      }
      },
    ],
    series: [
      {
        name: '新增会员数',
        type: 'line',
        barWidth:50,
        data: []
      },
    ]
  }
};
//会员概览--消费密集度分布统计
export let intensityEcharts = {
  id: "intensityEcharts",
  charsOption: {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    },
    color: ['#9b8bba', '#e098c7','#8fd3e8'],
    legend: {
      data: ['消费密集度分布统计']
    },
    grid: {
      top: '9%',
      left: '3%',
      right: '5%',
      bottom: '8%',
      containLabel: true
      },
      dataZoom: [
        {
          show: false,
          start: 0,
          end: 100
        },
        {
          type: 'inside',
          start: 94,
          end: 100
        },
        {
          show: false,
          yAxisIndex: 0,
          filterMode: 'empty',
          width: 30,
          height: '80%',
          showDataShadow: false,
          left: '93%'
        }
      ],
    xAxis: [
      {
        type: 'category',
        data: [],
        axisPointer: {
          type: 'shadow'
        },
        splitLine: {
          show: true
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          formatter: '{value} 单'
      },
      splitLine: {
        show: true
      }
      },
    ],
    series: [
      {
        name: '消费密集度分布统计',
        type: 'line',
        barWidth:50,
        data: []
      },
    ]
  }
};
//会员概览--年龄分布与消费金额--人数
export let agePersonEcharts={
  id:"agePersonEcharts",
  charsOption:{
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)'
  },
  // legend: {
  //     orient: 'vertical',
  //     // left: 10,
  //     right:"40%",
  //     top:'30%',
  //     data: ['0~15元', '15~30元', '30~45元', '45~60元']
  // },

  color:["#0098d9","#6be6c1","#9bca63","#fcce10"],
  series: [
      {
          name: '来源',
          type: 'pie',
          radius: ['50%', '75%'],
          center: ['50%', '50%'],
          avoidLabelOverlap: false,
          label: {
              show: false,
              position: 'center'
          },
          emphasis: {
              label: {
                  show: true,
                  fontSize: '20',
                  fontWeight: 'bold'
              }
          },
          labelLine: {
              show: false
          },
          data: [
              {value: 335, name: '0~15元'},
              {value: 310, name: '15~30元'},
              {value: 234, name: '30~45元'},
              {value: 135, name: '45~60元'},
          ]
      }
  ]
  }
}
//会员概览--年龄分布与消费金额--金额
export let ageMoneyEcharts={
  id:"ageMoneyEcharts",
  charsOption:{
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)'
  },
  // legend: {
  //     orient: 'vertical',
  //     // left: 10,
  //     right:"40%",
  //     top:'30%',
  //     data: ['0~15元', '15~30元', '30~45元', '45~60元']
  // },

  color:["#d0648a","#f2b3c9","#22c3aa","#e6b600"],
  series: [
      {
          name: '来源',
          type: 'pie',
          radius: ['50%', '75%'],
          center: ['50%', '50%'],
          avoidLabelOverlap: false,
          label: {
              show: false,
              position: 'center'
          },
          emphasis: {
              label: {
                  show: true,
                  fontSize: '20',
                  fontWeight: 'bold'
              }
          },
          labelLine: {
              show: false
          },
          data: [
              {value: 335, name: '0~15元'},
              {value: 310, name: '15~30元'},
              {value: 234, name: '30~45元'},
              {value: 135, name: '45~60元'},
          ]
      }
  ]
  }
}
//会员概览--性别比例与消费金额--人数
export let sexPersonEcharts={
  id:"sexPersonEcharts",
  charsOption:{
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)'
  },
  // legend: {
  //     orient: 'vertical',
  //     // left: 10,
  //     right:"40%",
  //     top:'30%',
  //     data: ['0~15元', '15~30元', '30~45元', '45~60元']
  // },

  color:["#0098d9","#6be6c1","#9bca63","#fcce10"],
  series: [
      {
          name: '来源',
          type: 'pie',
          radius: ['50%', '75%'],
          center: ['50%', '50%'],
          avoidLabelOverlap: false,
          label: {
              show: false,
              position: 'center'
          },
          emphasis: {
              label: {
                  show: true,
                  fontSize: '20',
                  fontWeight: 'bold'
              }
          },
          labelLine: {
              show: false
          },
          data: [
              {value: 335, name: '0~15元'},
              {value: 310, name: '15~30元'},
              {value: 234, name: '30~45元'},
              {value: 135, name: '45~60元'},
          ]
      }
  ]
  }
}
//会员概览--性别比例与消费金额--金额
export let sexMoneyEcharts={
  id:"sexMoneyEcharts",
  charsOption:{
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)'
  },
  // legend: {
  //     orient: 'vertical',
  //     // left: 10,
  //     right:"40%",
  //     top:'30%',
  //     data: ['0~15元', '15~30元', '30~45元', '45~60元']
  // },

  color:["#d0648a","#f2b3c9","#22c3aa","#e6b600"],
  series: [
      {
          name: '来源',
          type: 'pie',
          radius: ['50%', '75%'],
          center: ['50%', '50%'],
          avoidLabelOverlap: false,
          label: {
              show: false,
              position: 'center'
          },
          emphasis: {
              label: {
                  show: true,
                  fontSize: '20',
                  fontWeight: 'bold'
              }
          },
          labelLine: {
              show: false
          },
          data: [
              {value: 335, name: '0~15元'},
              {value: 310, name: '15~30元'},
              {value: 234, name: '30~45元'},
              {value: 135, name: '45~60元'},
          ]
      }
  ]
  }
}
//客价单  左边
export let customLeftEcharts = {
  id: "customLeftEcharts",
  charsOption: {
    title: {
      left: 'center',
      textStyle: {color: "#ccc", fontSize: "18", fontWeight: "400"},
    },
    tooltip: {
      formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    // legend: {
    //   orient: 'vertical',
    //   left: 0,
    //   data: []
    // },
    color:['#dd3333', '#ff8811','#ffcc00','#bbdd11',"#77cc22"],
    series: [
      {
        name: '来源',
        type: 'pie',
        radius: '65%',
        center: ['50%', '45%'],
        data: [],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          },
        }
      }
    ]
  }
};
//客价单  右边
export let customRightEcharts = {
  id: "customRightEcharts",
  charsOption: {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    },
    color: ['#0090eb'],
    grid: {
      top: '3%',
      left: '0%',
      right: '2%',
      bottom: '3%',
      containLabel: true
      },
      dataZoom: [
        {
          show: false,
          start: 0,
          end: 100
        },
        {
          show: false,
          type: 'inside',
          start: 30,
          end: 70
        },
        {
          show: false,
          yAxisIndex: 0,
          filterMode: 'empty',
          width: 10,
          height: '80%',
          showDataShadow: false,
          left: '93%'
        }
      ],
    xAxis: [
      {
        type: 'category',
        data: [],
        axisPointer: {
          type: 'shadow'
        },
        axisTick:{
          length:3
        },
        axisLabel: {
          rotate: 60,
          },
      }
    ],
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          formatter: '{value}元'
      }
      },
    ],
    series: [
      {
        name: '新增会员数',
        type: 'bar',
        barGap: 2,
        barWidth:15,
        data: []
      },
    ]
  }
};
//积分分布
export let integralEcharts = {
  id: "integralEcharts",
  charsOption: {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    },
    color: ['#00ccff', '#e098c7','#8fd3e8'],
    grid: {
      top: '11%',
      left: '0%',
      right: '3%',
      bottom: '3%',
      containLabel: true
      },
      dataZoom: [
        {
          show: false,
          start: 0,
          end: 100
        },
        {
          type: 'inside',
          start: 94,
          end: 100
        },
        {
          show: false,
          yAxisIndex: 0,
          filterMode: 'empty',
          width: 30,
          height: '80%',
          showDataShadow: false,
          left: '93%'
        }
      ],
    xAxis: [
      {
        type: 'category',
        data: ['0人','1人','2人','3人','4人','5人'],
        axisPointer: {
          type: 'shadow'
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          formatter: '{value} 次'
      }
      },
    ],
    series: [
      {
        name: '新增会员数',
        type: 'bar',
        barWidth:30,
        data: [2,3,5,2,5,8,20]
      },
    ]
  }
};
//储值卡分析
// export let saveCardEcharts = {
//   id: "saveCardEcharts",
//   charsOption: {
//     title: {
//         text: ' ',
//         left:0,
//         top:0,
//         textStyle: {color: "#ccc", fontSize: "18", fontWeight: "400"},
//     },
//     tooltip: {
//       trigger: 'axis',
//       axisPointer: {
//         type: 'cross',
//         crossStyle: {
//           color: '#999'
//         }
//       }
//     },
//     color: ['#5a4afc', '#ff4855'],
//     legend: {
//       data: ['储值卡消费总金额', '消费总金额']
//     },
//     grid: {
//       top: '11%',
//       left: '0%',
//       right: '3%',
//       bottom: '3%',
//       containLabel: true
//       },
//     xAxis: [
//       {
//         type: 'category',
//         data: [],
//         axisPointer: {
//           type: 'shadow'
//         }
//       }
//     ],
//     yAxis: [
//       {
//         type: 'value',
//         name: '',
//         // min: 0,
//         // max: 5,
//         // interval: 1,
//         axisLabel: {
//           formatter: '{value}元'
//         }
//       },
//     ],
//     series: [
//       {
//         name: '储值卡消费总金额',
//         type: 'line',
//         data: []
//       },
//       {
//         name: '消费总金额',
//         type: 'line',
//         data: [],
//         smooth:true
//       },
//     ]
//   }
// };




// WEBPACK FOOTER //
// ./src/page/home/options/reportEcharts.js